import * as React from "react";
import { Grid, makeStyles, Tab, Tabs } from "@material-ui/core";

import SearchResultListItem from "./SearchResultListItem";
import { BeaconContentSearchResult, SearchTypes } from "../../../api/graphQL/queryModels";

interface SearchResultListProps {
    results: BeaconContentSearchResult[];
    onItemSelected: (selectedDocumentId: string, rank: number) => unknown;
}

const useStyles = makeStyles(() => ({
    tabs: {
        "& .MuiTab-root": {
            fontSize: "1.25rem"
        }
    }
}));

const SearchResultList = (props: SearchResultListProps) => {
    const classes = useStyles();
    const [tab, setTab] = React.useState<SearchTypes>(SearchTypes.Story);

    const onItemSelected = (result: BeaconContentSearchResult, rank: number) => () => {
        props.onItemSelected(result.id, rank);
    };

    const { results } = props;

    return (
        <Grid container spacing={2}>
            <Tabs value={tab} className={classes.tabs} onChange={(_e, newValue) => setTab(newValue)}>
                <Tab label="Stories" value={SearchTypes.Story} />
                <Tab label="Items" value={SearchTypes.Item} />
            </Tabs>
            {results
                ? results
                      .filter((result) => (tab as readonly string[]).includes(result.type))
                      .map((result, index) => {
                          return (
                              <Grid key={result.id} item xs={12}>
                                  <SearchResultListItem result={result} onClick={onItemSelected(result, index + 1)} />
                              </Grid>
                          );
                      })
                : null}
        </Grid>
    );
};

export default SearchResultList;
